import { METHOD } from 'services/method'

export const API_PRODUCT_BY_CATEGORY = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/category',
        method: METHOD.GET,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/main-page/home-page/category/product',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/category',
        method: METHOD.PUT,
    },
}
